import createIcon from '../../createIcon';

/**
 * @component @name NetworkPing
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMTQuNjdMMy40MSA2LjA5TDIgNy41TDEwLjUgMTZINFYxOEgyMFYxNkgxMy41TDE4LjY1IDEwLjg1QzE4LjkxIDEwLjk1IDE5LjIgMTEgMTkuNSAxMUMyMC44OCAxMSAyMiA5Ljg4IDIyIDguNUMyMiA3LjEyIDIwLjg4IDYgMTkuNSA2QzE4LjEyIDYgMTcgNy4xMiAxNyA4LjVDMTcgOC44NSAxNy4wNyA5LjE3IDE3LjIgOS40N0wxMiAxNC42N1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NetworkPing = createIcon('NetworkPing', [
  [
    'path',
    {
      d: 'M12 14.67L3.41 6.09L2 7.5L10.5 16H4V18H20V16H13.5L18.65 10.85C18.91 10.95 19.2 11 19.5 11C20.88 11 22 9.88 22 8.5C22 7.12 20.88 6 19.5 6C18.12 6 17 7.12 17 8.5C17 8.85 17.07 9.17 17.2 9.47L12 14.67Z',
      key: '189sd6',
    },
  ],
]);

export default NetworkPing;
